import PropTypes from "prop-types";
import React from "react";

const CloudOutgoingIcon = props => {
  const { width, height, fill } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="
      M60 130
      a30 30 0 0 1 0-60
      a40 40 0 0 1 80 0
      a30 30 0 0 1 0 60
    "
        stroke={fill}
        strokeWidth="10"
      />

      <line x1="100" y1="120" x2="100" y2="180" stroke={fill} strokeWidth="20" />
      <polyline points="80,160 100,180 120,160" stroke={fill} strokeWidth="20" />
    </svg>
  );
};

CloudOutgoingIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
};

CloudOutgoingIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: "",
};

export default CloudOutgoingIcon;
